import { lightRelation, type LightRelation } from './sun'

export function lightRelationLabel(r: LightRelation): string {
  switch (r) {
    case 'backlight':
      return 'Pod światło (backlight)'
    case 'frontlight':
      return 'Światło z tyłu kamery (front light)'
    case 'sidelight':
      return 'Światło boczne'
  }
}

export { lightRelation }
